<script lang="ts">
	// import { createEventDispatcher } from 'svelte';
	import { format } from 'svelte-i18n';
	import { Text, Select, Input, Stack, Token, IconButton } from '@Shelly/shelly-design-system';
	import { _init_exchange_based_conditions } from '../../../../../../helpers/init_exchange_based_conditions';
	import {
		// EnergyExchangeConditionUI,
		is_energy_exchange_ui,
	} from '../../../../../../../../types/EnergyExchangeConditionUI';
	import { exchangeMarketCountryAndRegionNames } from '../../../../../../helpers/utilities_ui_to_scenes';
	import { capFirstChar, removeOrAddUnderscore } from 'src/helpers/utilities';
	import { WHEN_WIZARD_STEPS_INDEXES } from '../../helpers/when-wizard-helpers';

	export let sceneData: any;

	let selectedMarket = {
		title: '',
		regions: [],
		value: undefined,
	};

	function translatingTitles(arrOfNames) {
		return arrOfNames.map((element) => {
			return {
				...element,
				title: $format(element.title),
			};
		});
	}

	const components = _init_exchange_based_conditions();

	let energy_exchange_component = components.find((el) => el.cond === 'energy_exchange');

	let countries_val = translatingTitles(energy_exchange_component.countries);

	let energy_exchange_component_val = energy_exchange_component;

	let selectedExchange = { title: 'Select region', value: undefined };

	let selectedMin = {
		title: 'Valid for the current minute',
		value: 0,
	};

	const min_options = [
		{
			title: 'Valid for current minute',
			value: 0,
		},
		{
			title: 'Valid for the next 5 min.',
			value: 5,
		},
		{
			title: 'Valid for the next 10 min.',
			value: 10,
		},
		{
			title: 'Valid for the next 15 min.',
			value: 15,
		},
	];

	const formatLessMoreThansStateCondition = (cond, operator, character, value) => {
		switch (cond) {
			case 'energy_exchange':
				return $format(
					`scene_energy_exchange_${removeOrAddUnderscore(operator, 'addUnderscore')}`,
					{
						values: {
							operator: $format(`operator_${operator.split(' ').join('_')}`),
							value: value,
							character: character,
						},
						default: `${operator} ${value} ${character}`,
					},
				);
			default:
				return `When the ${cond} is ${operator} ${sceneData.active_condition.value} ${character}`;
		}
	};

	if (is_energy_exchange_ui(sceneData.translated)) {
		sceneData.active_condition = { ...sceneData.translated };
		let {
			energy_exchange_component = {},
			selectedCountry = {
				title: '',
				regions: [],
				value: undefined,
			},
			selectedRegion = { title: 'Select region', value: undefined },
			countries = [],
		} = exchangeMarketCountryAndRegionNames(sceneData.active_condition.exchange_market);

		countries_val = translatingTitles(countries);

		energy_exchange_component_val = energy_exchange_component;

		selectedMarket = {
			title: $format(selectedCountry.title),
			value: selectedCountry.value,
			regions: translatingTitles(selectedCountry?.regions),
		};

		selectedExchange = {
			...selectedRegion,
			title: $format(selectedRegion.title),
		};

		selectedMin = min_options.find((el) => el.value === Number(sceneData.active_condition.minutes));
	}

	const handle_market_change = (e) => {
		selectedMarket = {
			title: $format(e.detail.title),
			regions: translatingTitles(e.detail.regions),
			value: e.detail.value,
		};

		sceneData.active_condition = {
			...sceneData.active_condition,
			exchange_market: selectedMarket.value,
			character: e.detail.character,
			operator: '',
			value: 0,
		};
		selectedExchange = { title: 'Select region', value: undefined };
	};

	const handle_exchange_change = (e) => {
		selectedExchange = e.detail;

		selectedMarket = {
			...selectedMarket,
			value: `${selectedMarket.value}|${selectedExchange.value}`,
		};
		sceneData.active_condition.exchange_market = selectedMarket.value;
	};

	const validateWizardStepEnergy = () => {
		sceneData.validStepIndex = WHEN_WIZARD_STEPS_INDEXES.EXCHANGE_STEP;
		sceneData.isValid =
			selectedMarket.value !== undefined &&
			sceneData.active_condition.cond_name !== '' &&
			sceneData.active_condition.value &&
			sceneData.active_condition.operator != '' &&
			((selectedMarket.regions.length > 0 && selectedExchange.value !== undefined) ||
				(selectedMarket.regions.length === 0 && selectedExchange.value === undefined));
	};

	$: (sceneData, validateWizardStepEnergy());
</script>

<Text element="h2" class="mb-s">
	{$format('label_select_exchange', {
		default: 'Select exchange',
	})}
</Text>

<Select
	aria-labelledby="select-oqznqo2"
	icon="fas fa-globe"
	size="l"
	class={selectedMarket.regions.length > 0 ? 'mb-s' : 'mb-l'}
	options={countries_val}
	label={$format('label_select_country', {
		default: 'Country',
	})}
	value={selectedMarket}
	disabled={false}
	on:change={(e) => handle_market_change(e)}
	id="select-syfshn6"
/>

{#if selectedMarket.regions.length > 0}
	<Select
		aria-labelledby="select-7da7oaq"
		icon="fas fa-globe"
		size="l"
		class={selectedMarket.value ? 'mb-l' : ''}
		options={selectedMarket.regions}
		label={$format('label_select_region', {
			default: 'Region',
		})}
		value={selectedExchange}
		disabled={false}
		on:change={(e) => handle_exchange_change(e)}
		id="select-7da7oaq"
	/>
{/if}

{#if selectedMarket.value !== undefined}
	<Text element="h2" class="mb-s">
		{$format('energy_step_text_price_day', {
			default: 'Day ahead price is',
		})}
	</Text>
	<Stack gap="s">
		{#if energy_exchange_component_val.ui_operators}
			<div class="d-flex flex-wrap" style="gap:var(--spacing-s)">
				{#each energy_exchange_component_val.ui_operators as op}
					<Token
						id="token-2igbc88"
						size="m"
						icon={op === 'less than' ? 'fas fa-arrow-down' : 'fas fa-arrow-up'}
						title={sceneData.active_condition.value !== undefined
							? capFirstChar(
									formatLessMoreThansStateCondition(
										energy_exchange_component_val.cond,
										op,
										sceneData.active_condition.character,
										sceneData.active_condition.value,
									),
								)
							: capFirstChar(
									formatLessMoreThansStateCondition(
										energy_exchange_component_val.cond,
										op,
										sceneData.active_condition.character,
										0,
									),
								)}
						selected={energy_exchange_component_val.cond ===
							sceneData.active_condition.cond_name &&
							sceneData.active_condition.operator === op}
						value={op}
						on:click={() => {
							sceneData.active_condition = {
								...sceneData.active_condition,
								cond_name: energy_exchange_component_val.cond,
								operator: op,
							};
						}}
					/>
				{/each}
			</div>
			<div class="d-flex">
				<IconButton
					aria-label={$format('button_decrease_value', { default: 'Decrease value' })}
					icon="fas fa-minus"
					on:click={() => {
						sceneData.active_condition.value = +sceneData.active_condition.value - 1;
					}}
				/>
				<Input
					aria-label={$format('input_set_value', { default: 'Set value' })}
					class="width-md-s width-sm-full ml-s mr-s"
					size="m"
					type="number"
					icon="fas fa-calculator"
					value={`${sceneData.active_condition.value}`}
					on:input={(e) => {
						sceneData.active_condition.value = +e.target.value;
					}}
					id="input-bcw8bbk"
				/>
				<IconButton
					aria-label={$format('button_increase_value', { default: 'Increase value' })}
					icon="fas fa-plus"
					on:click={() => {
						sceneData.active_condition.value = +sceneData.active_condition.value + 1;
					}}
				/>
			</div>
		{/if}
	</Stack>

	<!--This option is hidden for now-->
	<!-- <Select
		icon={null}
		size="m"
		class="mb-s"
		options={min_options}
		label={'Select how long to be valid condition'}
		value={selectedMin}
		disabled={false}
		on:change={e => {
			selectedMin = { ...e.detail };
			active_condition.minutes = selectedMin.value || 0;
			
		}} id="select-hux4vpl" /> -->
{/if}
